/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

export const CONFIRMATION_TYPES = {
    UNINSTALL_PREFERENCES: 'uninstallpreferences',
    FULL_APP_UPDATE_CONFIRMATION_WITH_ADVANCED_OPTIONS: 'fullappupdateconfirmationwithadvancedoptions',
    AUTO_UPDATE_WITH_ADVANCED_OPTIONS: 'autoupdateinfo',
    APP_NOT_APPLICABLE: 'appnotapplicable',
    DISABLE_AU_FOR_UNINSTALL: 'disableautoupdateforuninstall',
    DISABLE_AU_FOR_INSTALL: 'disableautoupdateforinstall',
    PREV_VER_WITH_DISABLED_AU: 'prevversionconfirmationwithdisableautoupdate',
    PREV_VER: 'prevversionconfirmation',
    CONFLICTING_PROCESS: 'conflictingprocess',
    LAUNCH_CONFIRMATION: 'launchconfirmation',
    PII: 'pii',
    PRODUCT_UNAVAILABLE: 'productunavailable',
    INCOMPATIBLE: 'incompatible',
    RETRYABLE_ERROR: 'retryableerror',
    ELEVATION_INFO: 'elevationinfoprompt',
    ERROR_INFO: 'errorinfo',
};

export const DIALOG_REPO_KEYS = {
    UNINSTALL: 'uninstall',
    UPDATE: 'update',
    CONFLICT: 'conflict',
    PII: 'pii',
    LaunchConfirmation: 'LaunchConfirmation',
    PRODUCT_UNAVAILABLE: 'productUnavailable',
    INCOMPATIBLE: 'incompatible',
    RETRYABLE_ERROR: 'retryableError',
    AUTO_UPDATE: 'autoUpdate',
    AUTO_UPDATE_WITH_ADVANCED_OPTIONS: 'autoUpdateWithAdvanced',
    DISABLE_AU_FOR_UNINSTALL: 'disableAUUninstall',
    DISABLE_AU_FOR_INSTALL: 'disableAUInstall',
    PREV_VER_WITH_DISABLED_AU: 'prevVerDisabledAu',
    PREV_VER: 'prevVer',
};

export const CONFIRMATION_BOX_BTN_IDS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    WARNING: 'warning',
    BACK: 'back',
    DONE: 'done',
    RETRY: 'retry',
    CANCEL: 'cancel',
    CONTINUE: 'continue',
};

export const CONFIRMATION_BOX_LINK_IDS = {
    ERROR_SUMMARY_LINK: 'summary-link',
    ERROR_CUSTOMER_SUPPORT_LINK: 'customer-support-link',
    ERROR_FIX_LINK: 'fix-link',
};

export const CONFIRMATION_STATUS = {
    NEED_CONFIRMATION: 'needconfirmation',
    CLOSE_CONFIRMATION: 'closeconfirmation',
};

export const CONFIRMATION_TYPES_TO_DIALOG_REPO_KEYS = (() => {
    const typesToKeys = {};
    typesToKeys[CONFIRMATION_TYPES.UNINSTALL_PREFERENCES] = DIALOG_REPO_KEYS.UNINSTALL;
    /* eslint-disable max-len */
    typesToKeys[CONFIRMATION_TYPES.FULL_APP_UPDATE_CONFIRMATION_WITH_ADVANCED_OPTIONS] = DIALOG_REPO_KEYS.UPDATE;
    typesToKeys[CONFIRMATION_TYPES.CONFLICTING_PROCESS] = DIALOG_REPO_KEYS.CONFLICT;
    typesToKeys[CONFIRMATION_TYPES.PII] = DIALOG_REPO_KEYS.PII;
    typesToKeys[CONFIRMATION_TYPES.PRODUCT_UNAVAILABLE] = DIALOG_REPO_KEYS.PRODUCT_UNAVAILABLE;
    typesToKeys[CONFIRMATION_TYPES.INCOMPATIBLE] = DIALOG_REPO_KEYS.INCOMPATIBLE;
    typesToKeys[CONFIRMATION_TYPES.RETRYABLE_ERROR] = DIALOG_REPO_KEYS.RETRYABLE_ERROR;
    typesToKeys[CONFIRMATION_TYPES.AUTO_UPDATE_WITH_ADVANCED_OPTIONS] = DIALOG_REPO_KEYS.AUTO_UPDATE_WITH_ADVANCED_OPTIONS;
    typesToKeys[CONFIRMATION_TYPES.DISABLE_AU_FOR_UNINSTALL] = DIALOG_REPO_KEYS.DISABLE_AU_FOR_UNINSTALL;
    typesToKeys[CONFIRMATION_TYPES.DISABLE_AU_FOR_INSTALL] = DIALOG_REPO_KEYS.DISABLE_AU_FOR_INSTALL;
    typesToKeys[CONFIRMATION_TYPES.PREV_VER_WITH_DISABLED_AU] = DIALOG_REPO_KEYS.PREV_VER_WITH_DISABLED_AU;
    typesToKeys[CONFIRMATION_TYPES.PREV_VER] = DIALOG_REPO_KEYS.PREV_VER;
    return typesToKeys;
    /* eslint-enable */
})();
